import Vue from 'vue'
import Vuex from 'vuex'

import thread from './modules/thread'
import category from './modules/category'
import moderation from './modules/moderation'
import apiDomain from '../config'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		meta: {
			lang: 'en',
			name: '',
			title: '',
			categories: [
				{ name: 'All', value: 'ALL', color: '#1565C0' }
			],
			games: [],
			gamesDict: {},
			giveaways: [],
			main_giveaway: {},
			giveaway: {},
			discussions:[],
			win: 0,
			nmessages: {},
			comments: []
		},
    	gameID: null,
		accountTabs: 0,
		accountModal: false,
		username: '',
		email: true,
		points: 0,
		level: 0,
		admin: false,
		role: '',
		user_id: '',
		profile_photo_path: '',
		show404Page: false,
		ajaxErrors: [],
		ajaxErrorsModal: false,
		MinQueryLength: 2
	},
	getters: {
		categoriesWithoutAll (state) {
			let categories =
				state.meta.categories
				.filter(category => ['ALL', 'OTHER'].indexOf(category.value) === -1 )

			categories.unshift({
				name: 'Select a category',
				disabled: true
			})

			return categories.filter(category => category.value !== 'ALL' )
		},
		title (state) {
      // return 'Forum IDC' + (state.meta.title && ` | ${state.meta.title}`)
      return 'Forum IDC' + ((state.gameID && state.meta.name && ` | ${state.meta.name}`) || (state.gameID && state.meta.gamesDict && state.meta.gamesDict[state.gameID] && ` | ${state.meta.gamesDict[state.gameID].name}`) || "")
		},
		alphabetizedCategories (state) {
			return state.meta.categories.sort((a, b) => {
				if(a.name === 'All') return -1
				if(a.name === 'Other' || b.name === 'Other') return -1

				if(a.name < b.name) {
					return -1
				} else if (a.name > b.name) {
					return 1
				}

				return 0
			})
    },
    alphabetizedGames (state) {
			return state.meta.games.sort((a, b) => {
				if(a.name < b.name) {
					return -1
				} else if (a.name > b.name) {
					return 1
				}

				return 0
			})
    },
    isGameExist (state) {
      return function(gameseo){
        return state.meta.gamesDict[gameseo] || false
      }
    },
    isAdmin (state) {
      return state.role == 'Super' || state.role == 'Admin' || state.role == 'Moderator'
    },
    canManageUser (state) {
      return state.role == 'Super'
    },
    canViewReport (state) {
      return state.role == 'Super' || state.role == 'Admin'
    },
    canManageSetting (state) {
      return state.role == 'Super' || state.role == 'Admin'
    },
    canManageThread (state) {
      return state.role == 'Super' || state.role == 'Admin' || state.role == 'Moderator'
    },
	},
	actions: {
		setTitle ({ state, getters }, value) {
			console.log(state,getters,value)
				// state.meta.title = value
				// document.title = getters.title
		},
		checkGameValidity({ state }, value) {
			if(state.meta.games.length > 0 && value && !state.meta.gamesDict[value])
				this.commit('set404Page', true)
		}		
	},
	mutations: {
		setLang (state, lang) {
			state.meta.lang = lang
		},
		setWin (state, value) {
			state.meta.win = value
		},
		set404Page (state, value) {
			state.show404Page = value
		},
		setGameID (state, value) {
		state.gameID = value
		},
		setAccountTabs (state, index) {
			state.accountTabs = index;
		},
		setSelectOptions (state, payload) {
			state.selectOptions[payload.name] = payload.value;
		},
		setAccountModalState (state, value) {
			state.accountModal == value;
		},
		setAjaxErrorsModalState (state, value) {
			state.ajaxErrorsModal = value;
		},
		setAjaxErrors (state, value) {
			state.ajaxErrors = value
		},
		setProfile_photo_path (state, value) {
			state.profile_photo_path = value
		},
		setNmessages (state, value) {
			state.meta.nmessages = value
		},
		setUsername (state, value) {
			state.username = value
		},
		setEmail (state, value) {
			state.email = value
		},
		setPoints (state, value) {
			state.points = value
		},
		setLevel (state, value) {
			state.level = value
		},
		setAdmin (state, value) {
			state.admin = value
		},
		setRole (state, value) {
			state.role = value
		},
		setUserID (state, value) {
			state.user_id = value
		},
		setComments (state, value) {
			state.meta.comments = value
		},
		setSettings (state, value) {
			state.meta.name = value.forumName || ''
			state.meta.description = value.forumDescription || ''
			state.meta.showDescription = value.showDescription || false
		},
		addCategories (state, value) {
			if(Array.isArray(value)) {
				state.meta.categories = [
					{ name: 'All', value: 'ALL', color: '#1565C0' },
					...value
				]
			} else {
				state.meta.categories.push(value)
			}
		},
		removeCategory (state, id) {
			let category = state.meta.categories.filter(c => c.id === id)
			let index = state.meta.categories.indexOf(category)

			state.meta.categories.splice(index, 1)
		},
		updateCategory (state, updated) {
			let category = state.meta.categories.filter(c => c.id === updated.id)
			let index = state.meta.categories.indexOf(category)

			state.meta.categories.splice(index, 1, updated)
		},

		addGames (state, value) {
			if(Array.isArray(value)) {
				state.meta.gamesDict = {}
				state.meta.games = value
				value.map(g => g.id && (state.meta.gamesDict[g.seoname]=g))
			} else {
				state.meta.games.push(value)
				value.id && (state.meta.gamesDict[value.seoname]=value)
			}
		},

		setGiveaways (state, value){
			state.meta.giveaways = value;
		},

		setMainGiveaways(state, value){
			state.meta.main_giveaway = value;
		},

		setGiveaway(state, value){
			state.meta.giveaway = value
		},

		setDiscussions(state, value){
			state.meta.discussions = value;
		}

	},
	modules: { thread, category, moderation }
})
